import Vue from 'vue'
import Router from 'vue-router'

import login from '../module/login'
import mains from '../module/mains'
import questionnaire from '../module/questionnaire'
import questionnaireAnswer from '../module/questionnaireAnswer'
import questionnaireAnswerDetails from '../module/questionnaireAnswerDetails'
import projects from '../module/projects'
import projectManage from '../module/projectManage'
import projectDetails from '../module/projectDetails'
import projectMemberManage from '../module/projectMemberManage'
import sales from '../module/sales'
import questionnaireItemManage from '../module/questionnaireItemManage'
import syncAWS from '../module/syncAWS'
import userManage from '../module/userManage'
import userDetail from '../module/userDetail'
import eloBatch from '../module/eloBatch'
import questionnaireStatus from '../module/questionnaireStatus'
import managementPointEdit from '../module/managementPointEdit'



Vue.use(Router) 

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/login2',
      name: 'login2',
      component: login
    },
    {
      path: '/mains',
      name: 'mains',
      component: mains
    },
    {
      path: '/questionnaire/:backScreenId/:directEvalFlg?/:evaluateeMemberID?/:projectID?',
      name: 'questionnaire',
      component: questionnaire
    },
    {
      path: '/questionnaireAnswer/:evaluateeMemberID?/:year?',
      name: 'questionnaireAnswer',
      component: questionnaireAnswer
    },
    {
      path: '/questionnaireAnswerDetails/:questionnaireID?/:evaluateeMemberID?',
      name: 'questionnaireAnswerDetails',
      component: questionnaireAnswerDetails
    },
    {
      path: '/projects/:year?',
      name: 'projects',
      component: projects
    },
    {
      path: '/projectDetails/:backScreenId/:projectID/:year?',
      name: 'projectDetails',
      component: projectDetails
    },
    {
      path: '/projectManage/:backScreenId/:operationType/:projectID?',
      name: 'projectManage',
      component: projectManage
    },
    {
      path: '/projectMemberManage/:backScreenId/:projectID/:year/:yearMonth?/:memberID?',
      name: 'projectMemberManage',
      component: projectMemberManage
    },
    {
      path: '/managementPointEdit/:yearMonth/:memberID/:memberName',
      name: 'managementPointEdit',
      component: managementPointEdit,
      props: true
    },
    {
      path: '/sales/:evaluateeMemberID?/:year?',
      name: 'sales',
      component: sales
    },
    {
      path: '/questionnaireItemManage',
      name: 'questionnaireItemManage',
      component: questionnaireItemManage
    },
    {
      path: '/userManage',
      name: 'userManage',
      component: userManage
    },
    {
      path: '/userDetail/:operationType/:memberID/',
      name: 'userDetail',
      component: userDetail
    },
    {
      path: '/syncAWS',
      name: 'syncAWS',
      component: syncAWS
    },
    {
      path: '/eloBatch',
      name: 'eloBatch',
      component: eloBatch
    },
    {
      path: '/questionnaireStatus',
      name: 'questionnaireStatus',
      component: questionnaireStatus
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 1000)
      });
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js